/** InsCoder WANG.J 2025-09-01 B + SVG fade-in animation JavaScript **/

document.addEventListener('DOMContentLoaded', function() {
  // 查找所有的 light animation section
  const sections = document.querySelectorAll('.cust-light-animation');
  
  if (sections.length === 0) return;
  
  // 创建 Intersection Observer 来监听 section 进入视口
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const section = entry.target;
        const svgs = section.querySelectorAll('.fade-in-svg');
        
        // 为每个 SVG 添加淡入动画，可以设置延迟以实现依次出现的效果
        svgs.forEach(function(svg, index) {
          setTimeout(function() {
            svg.classList.add('visible');
          }, index * 150); // 每个 SVG 延迟 150ms
        });
        
        // 动画触发后停止观察这个 section
        observer.unobserve(section);
      }
    });
  }, {
    threshold: 0.3, // 当 section 30% 可见时触发
    rootMargin: '0px 0px -50px 0px' // 提前一点触发动画
  });
  
  // 开始观察所有的 light animation sections
  sections.forEach(function(section) {
    observer.observe(section);
  });
});

/** InsCoder WANG.J 2025-09-01 E + SVG fade-in animation JavaScript **/
